/* START_MODULE_CONTRACT
 * PURPOSE: Frontend API client для проектов (CRUD).
 * SCOPE: HTTP-вызовы /api/projects.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API, V-M-FE-API, M-PROJECT
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * getProjects - список проектов текущего пользователя.
 * createProject - создать проект.
 * updateProject - переименовать проект.
 * deleteProject - удалить проект.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: function contracts и парные END_METHOD.
 * END_CHANGE_SUMMARY
 */

import apiClient from './apiClient';

/* START_METHOD_getProjects */
/* START_CONTRACT: getProjects
 * PURPOSE: Получить список проектов пользователя.
 * INPUTS: { signal: AbortSignal - для отмены запроса }
 * OUTPUTS: { Promise<AxiosResponse> - GET /api/projects }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-PROJECT
 * END_CONTRACT: getProjects
 */
export function getProjects(signal) {
  return apiClient.get('/api/projects', { signal });
}
/* END_METHOD_getProjects */

/* START_METHOD_createProject */
/* START_CONTRACT: createProject
 * PURPOSE: Создать новый проект.
 * INPUTS: { name: string }
 * OUTPUTS: { Promise<AxiosResponse> - POST /api/projects }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-PROJECT
 * END_CONTRACT: createProject
 */
export function createProject({ name }) {
  return apiClient.post('/api/projects', { name });
}
/* END_METHOD_createProject */

/* START_METHOD_updateProject */
/* START_CONTRACT: updateProject
 * PURPOSE: Обновить имя проекта.
 * INPUTS: { id: number|string, name: string }
 * OUTPUTS: { Promise<AxiosResponse> - PUT /api/projects/{id} }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-PROJECT
 * END_CONTRACT: updateProject
 */
export function updateProject(id, { name }) {
  return apiClient.put(`/api/projects/${id}`, { name });
}
/* END_METHOD_updateProject */

/* START_METHOD_deleteProject */
/* START_CONTRACT: deleteProject
 * PURPOSE: Удалить проект.
 * INPUTS: { id: number|string }
 * OUTPUTS: { Promise<AxiosResponse> - DELETE /api/projects/{id} }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-PROJECT
 * END_CONTRACT: deleteProject
 */
export function deleteProject(id) {
  return apiClient.delete(`/api/projects/${id}`);
}
/* END_METHOD_deleteProject */
